import React, { useEffect, useState } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import toastService from "./_services/toastService";
import SatAPI from "./_services/sat";

const TamperGuardedRoute = (props) => {
  const nav = useHistory();
  const isSATUser = localStorage.getItem("isSATUser");
  const api = SatAPI();

  useEffect(() => {
    api.getMyself().then((res) => {
        if(res.isSATUser.toString() != isSATUser){
           api.createLog({message: "Tamper attempt detected"});
            nav.push("/");
        }
    })
  }, [])

  return (
    <Route path={props.path}>
      {props.children}
    </Route>
  );
};

export default TamperGuardedRoute;